import en from './en'
import pl from './pl'

export const messages = {
  en,
  pl
}

export type MessageSchema = typeof en
